module.exports = __webpack_public_path__ + "90fbd70d11fbf84dbc8e0eefbe1e570f.svg";